// extracted by mini-css-extract-plugin
export var borderRadius = "_9k-4";
export var large = "_9k-3";
export var logoContainer = "_9k-0";
export var nameLogo = "_9k-2";
export var small = "_9k-1";